import { themedStyled } from 'common/styles/styletron.theme';
import { Button } from 'components/elements/buttons';
import useFilterHandleComponent from 'hooks/filter/use-filter-handle-component';
import useFilterHandleParent from 'hooks/filter/use-filter-handle-parent';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

import FilterContent from './filter-content';

export interface DefaultQueryFilterProps {}

export default function DefaultQueryFilter(props: DefaultQueryFilterProps) {
  const { t } = useTranslation();
  const parentFilterHandler = useFilterHandleParent();
  const { onSelected, filters, onClearFilters } = useFilterHandleComponent();

  return (
    <StyledForm
      onSubmit={(e) => {
        e.preventDefault();
        parentFilterHandler.onChangeFilters(filters);
      }}
    >
      <Container>
        {filters
          .filter((filter) => !filter.name.includes('before'))
          .map((filter) => {
            return (
              <ContentItem key={filter.name}>
                <FilterContent
                  filter={filter}
                  onSelected={onSelected(filter.name)}
                  clearable
                />
              </ContentItem>
            );
          })}
        <SearchContainer>
          <Button style={{ height: 30 }} type="submit">
            {t('common:search')}
          </Button>
        </SearchContainer>
        {parentFilterHandler.onCheckFiltersHasValues(filters) && (
          <SearchContainer>
            <Button
              buttonType="secondary"
              style={{ height: 30 }}
              type="submit"
              onClick={() => {
                onClearFilters();
                parentFilterHandler.onClearFilters(filters);
              }}
            >
              {t('common:clear_filter')}
            </Button>
          </SearchContainer>
        )}
      </Container>
    </StyledForm>
  );
}

const Container = themedStyled('div', {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '8px',
});

const ContentItem = themedStyled('div', {
  flexBasis: '100%',
  '@media screen and (min-width: 768px)': {
    flexBasis: '22%',
  },
});

const StyledForm = themedStyled('form', {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
});

const SearchContainer = themedStyled('div', {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'end',
});
